import {
  faBagShopping,
  faBinoculars,
  faBuildingColumns,
  faChurch,
  faLandmark,
  faLocationDot,
  faMartiniGlass,
  faMugHot,
  faTicket,
  faTrainSubway,
  faTree,
  faUtensils,
  type IconDefinition,
} from '@fortawesome/free-solid-svg-icons'
import type { TranslationKey } from './i18n'

type MapIconKeyOf<Key> = Key extends `mapIcons.${infer MapIconKey}` ? MapIconKey : never
export type MapIconKey = MapIconKeyOf<TranslationKey>

export const MAP_ICONS: Record<MapIconKey, IconDefinition> = {
  landmark: faLandmark,
  church: faChurch,
  museum: faBuildingColumns,
  park: faTree,
  viewpoint: faBinoculars,
  cafe: faMugHot,
  bar: faMartiniGlass,
  restaurant: faUtensils,
  shop: faBagShopping,
  event: faTicket,
  transport: faTrainSubway,
  place: faLocationDot,
}
